<template>
  <div style="position:relative;">
    <div class="rasgado rasgado-superior"></div>

    <section class="itinerario-poster" ref="sectionRef">

      <h2 class="poster-title">Itinerary</h2>

      <div
        v-for="(evento, index) in eventos"
        :key="evento.nombre"
        class="poster-item"
        :ref="el => itemRefs[index] = el"
      >
        <img :src="evento.icono" class="poster-icon" />
        <p class="poster-text">
          <span class="evento-nombre">{{ evento.nombre }}</span>
          <span class="evento-hora">{{ evento.hora }}</span>
          <span v-if="evento.nota" class="evento-nota">{{ evento.nota }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioPoster',
  setup() {
    const eventos = [
      {
        nombre: 'Reception',
        hora: '5:00 PM',
        icono: require('@/assets/copa.png')
      },
      {
        nombre: 'Quinceañera Entrance and Waltz',
        hora: '5:10 PM',
        icono: require('@/assets/valss.png')
      },
      {
        nombre: 'Dinner',
        hora: '6:30 PM',
        icono: require('@/assets/cen.avif')
      },
      {
        nombre: 'Surprise Dance',
        hora: '7:45 PM',
        icono: require('@/assets/mon.png')
      },
      {
        nombre: 'Party',
        hora: '9:30 PM - onwards',
        nota: 'Let\'s enjoy the party!',
        icono: require('@/assets/fiesta.avif')
      }
    ]

    const itemRefs = ref([])
    const sectionRef = ref(null)

    onMounted(() => {
      itemRefs.value.forEach((el, index) => {
        if (!el) return

        const icon = el.querySelector('.poster-icon')
        const text = el.querySelector('.poster-text')

        gsap.set([icon, text], { opacity: 0 })

        const animations = [
          { y: 40 },
          { x: -40 },
          { scale: 0.85 },
          { x: 40 },
          { y: -40 },
          { scale: 0.9 },
          { x: -30 },
          { y: 30 }
        ]

        const fromVars = animations[index % animations.length]

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return

            gsap.fromTo(
              icon,
              { ...fromVars, opacity: 0 },
              { opacity: 1, x: 0, y: 0, scale: 1, duration: 1, ease: 'power3.out' }
            )

            gsap.fromTo(
              text,
              { y: 20, opacity: 0 },
              { y: 0, opacity: 1, duration: 1, delay: 0.2, ease: 'power2.out' }
            )

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, itemRefs, sectionRef }
  }
}
</script>

<style scoped>
.itinerario-poster {
  background:#f0c9d3;
  padding: 60px 20px 80px;
  text-align: center;
  position: relative; /* 🔥 necesario para que el rasgado se posicione aquí */
}

.poster-title {
  font-family: 'Playfair Display', serif;
  font-size: 44px;
  letter-spacing: 2px;
  color: #514e4e;
  margin-bottom: 50px;
}

.poster-item {
  margin-bottom: 42px;
}

.poster-icon {
  width: 114px;
  height: auto;
  margin-bottom: 12px;
}

.poster-text {
  font-family: 'Playfair Display', serif;
  color: #282727;
  line-height: 1.4;
}

.evento-nombre {
  display: block;
  font-size: 22px;
}

/* ===== CORTE SIMÉTRICO: INICIO Y FIN IDÉNTICOS ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background-color: #ffffff;
  z-index: 12;
  pointer-events: none;
}

/* Onda superior */
.rasgado-superior {
  top: 0;
  background: linear-gradient(to bottom, #ffffff 60%, #f4f4f4 100%);
  
  -webkit-mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,0 H1200 V30 C1020,65 880,20 720,55 C540,90 380,25 220,60 C100,85 40,35 0,45 Z' fill='%23000'/%3E%3C/svg%3E");
  mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,0 H1200 V30 C1020,65 880,20 720,55 C540,90 380,25 220,60 C100,85 40,35 0,45 Z' fill='%23000'/%3E%3C/svg%3E");
  -webkit-mask-size: 100% 100%;
  mask-size: 100% 100%;

  filter: 
    drop-shadow(0px 5px 6px rgba(0, 0, 0, 0.10)) 
    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.06));
}

.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

.evento-hora {
  display: block;
  font-size: 20px;
  font-style: italic;
  margin-top: 4px;
}
</style>
